module.exports = require("@splunk/themes/pick");